import { useQuery } from "@tanstack/react-query";
import { listWorksites } from "@/adapters/api";
import type { Canteiro } from "@/features/canteiros/types.ts";
import { toCanteiro } from "@/features/canteiros/utils.ts";

const MAX_PAGE_SIZE = 100;

export function useCanteiros() {
	return useQuery({
		queryKey: ["canteiros"],
		queryFn: async (): Promise<Canteiro[]> => {
			const { items } = await listWorksites({ pageSize: MAX_PAGE_SIZE });
			return items.map(toCanteiro);
		},
		staleTime: 60_000,
	});
}
